module.exports = __webpack_public_path__ + "static/media/danger.fa0ffcc9.svg";